import React from 'react';
import { CpuIcon, ZapIcon, SettingsIcon, BarChartIcon, BriefcaseIcon } from '../components/common/icons/Icons';

const services = [
  {
    title: 'End-to-End AI Solutions',
    description: 'From discovery and strategy to deployment, we provide comprehensive AI solutions tailored to your business.',
    icon: <CpuIcon />,
  },
  {
    title: 'AI Enablement',
    description: 'Empowering your teams and processes with intelligent automation and AI-driven tools.',
    icon: <ZapIcon />,
  },
  {
    title: 'Custom AI Product Development',
    description: 'We build bespoke AI products designed specifically to meet your unique business needs and challenges.',
    icon: <SettingsIcon />,
  },
  {
    title: 'Advanced Analytics & Data Insights',
    description: 'Leverage advanced analytics and data-driven insights for smarter, more informed decision-making.',
    icon: <BarChartIcon />,
  },
  {
    title: 'Seamless AI Integration',
    description: 'Integrate AI capabilities smoothly into your existing IT infrastructure for enhanced performance.',
    icon: <BriefcaseIcon />,
  },
  // New services
  {
    title: 'Enterprise Architecture Assessment',
    description: "Evaluate your organization's current IT landscape and align it with your business goals. Our expert architects analyze your systems, processes, and technologies to create a roadmap for optimal performance and scalability.",
    icon: <BriefcaseIcon />,
  },
  {
    title: 'Solution Architecture Design',
    description: 'Craft tailored IT solutions that address your specific business challenges. We design robust, scalable architectures that integrate seamlessly with your existing infrastructure while paving the way for future innovations.',
    icon: <SettingsIcon />,
  },
  {
    title: 'Cloud Migration Strategy',
    description: 'Navigate the complexities of cloud adoption with our expert guidance. We assess your readiness, design a migration strategy, and oversee the transition to ensure a smooth, secure, and efficient move to the cloud.',
    icon: <CpuIcon />,
  },
  {
    title: 'IT Governance Framework Development',
    description: 'Establish strong IT governance practices to manage risks, ensure compliance, and maximize the value of your IT investments. We help you create and implement frameworks that align with industry standards and your business objectives.',
    icon: <BarChartIcon />,
  },
  {
    title: 'Digital Transformation Consulting',
    description: 'Leverage our expertise to drive your digital transformation initiatives. We help you identify opportunities, overcome challenges, and implement cutting-edge technologies to keep your business competitive in the digital age.',
    icon: <ZapIcon />,
  },
  {
    title: 'Technology Stack Optimization',
    description: 'Streamline your technology stack for maximum efficiency and cost-effectiveness. Our architects analyze your current tools and recommend optimizations to reduce redundancy, improve performance, and enhance integration.',
    icon: <SettingsIcon />,
  },
];

function ServicesPage() {
  return (
    <div className="py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="section-title">What We Offer</h1>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="card flex flex-col items-start">
              <div className="mb-4">{service.icon}</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{service.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ServicesPage; 